import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Domain\Org\Http\Controllers\UserController::index
* @see app/Domain/Org/Http/Controllers/UserController.php:16
* @route '//org.launchstation.app/users'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '//org.launchstation.app/users',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Org\Http\Controllers\UserController::index
* @see app/Domain/Org/Http/Controllers/UserController.php:16
* @route '//org.launchstation.app/users'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Org\Http\Controllers\UserController::index
* @see app/Domain/Org/Http/Controllers/UserController.php:16
* @route '//org.launchstation.app/users'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\UserController::index
* @see app/Domain/Org/Http/Controllers/UserController.php:16
* @route '//org.launchstation.app/users'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Domain\Org\Http\Controllers\UserController::index
* @see app/Domain/Org/Http/Controllers/UserController.php:16
* @route '//org.launchstation.app/users'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\UserController::index
* @see app/Domain/Org/Http/Controllers/UserController.php:16
* @route '//org.launchstation.app/users'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\UserController::index
* @see app/Domain/Org/Http/Controllers/UserController.php:16
* @route '//org.launchstation.app/users'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Domain\Org\Http\Controllers\UserController::edit
* @see app/Domain/Org/Http/Controllers/UserController.php:27
* @route '//org.launchstation.app/users/{user}/edit'
*/
export const edit = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '//org.launchstation.app/users/{user}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Org\Http\Controllers\UserController::edit
* @see app/Domain/Org/Http/Controllers/UserController.php:27
* @route '//org.launchstation.app/users/{user}/edit'
*/
edit.url = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { user: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
    }

    return edit.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Org\Http\Controllers\UserController::edit
* @see app/Domain/Org/Http/Controllers/UserController.php:27
* @route '//org.launchstation.app/users/{user}/edit'
*/
edit.get = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\UserController::edit
* @see app/Domain/Org/Http/Controllers/UserController.php:27
* @route '//org.launchstation.app/users/{user}/edit'
*/
edit.head = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Domain\Org\Http\Controllers\UserController::edit
* @see app/Domain/Org/Http/Controllers/UserController.php:27
* @route '//org.launchstation.app/users/{user}/edit'
*/
const editForm = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\UserController::edit
* @see app/Domain/Org/Http/Controllers/UserController.php:27
* @route '//org.launchstation.app/users/{user}/edit'
*/
editForm.get = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\UserController::edit
* @see app/Domain/Org/Http/Controllers/UserController.php:27
* @route '//org.launchstation.app/users/{user}/edit'
*/
editForm.head = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Domain\Org\Http\Controllers\UserController::update
* @see app/Domain/Org/Http/Controllers/UserController.php:34
* @route '//org.launchstation.app/users/{user}'
*/
export const update = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '//org.launchstation.app/users/{user}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Domain\Org\Http\Controllers\UserController::update
* @see app/Domain/Org/Http/Controllers/UserController.php:34
* @route '//org.launchstation.app/users/{user}'
*/
update.url = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { user: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
    }

    return update.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Org\Http\Controllers\UserController::update
* @see app/Domain/Org/Http/Controllers/UserController.php:34
* @route '//org.launchstation.app/users/{user}'
*/
update.patch = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Domain\Org\Http\Controllers\UserController::update
* @see app/Domain/Org/Http/Controllers/UserController.php:34
* @route '//org.launchstation.app/users/{user}'
*/
const updateForm = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Domain\Org\Http\Controllers\UserController::update
* @see app/Domain/Org/Http/Controllers/UserController.php:34
* @route '//org.launchstation.app/users/{user}'
*/
updateForm.patch = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

const users = {
    index: Object.assign(index, index),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
}

export default users